import careersPath from "@faire/web-api--source/routes/careers";
import { useHistory } from "react-router-dom";
export var FlexibleWorkPolicyPage = function() {
    var history = useHistory();
    history.push(careersPath());
    //TODO: add new work policy page
    return null;
};
